import React from 'react';
import '../../FormBuilder.css';

const SiteElement = ({ component, isRequired }) => {
  const renderElement = () => {
    return (
      component.elementName === 'site' && (
        <label className='titleTextLbl'>
            {component.fieldName || "Site"}
            <span className='requiredContainer' style={{ color: 'red' }}>{isRequired(component)}</span>
        </label>
      )
    );
  };

  return (
    <div className='renderAllElements'>
      {renderElement()}
    </div>
  );
};

export default SiteElement;
